import api from "@helpers/api";
import { t } from "@i18n";
import { materialWriteBody } from "./materialWriteBody";

/**
 * Create a new material
 * @param {CreateMaterialDTO} materialDTO - Material data transfer object
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export async function createMaterial(materialDTO) {
    try {
        const payload = materialDTO.toPayload();
        const communityId = payload.community;
        const body = materialWriteBody(payload);
        const { data } = await api.post(`community/${communityId}/material`, body);

        if (data.id) {
            return { success: true, data };
        }

        return {
            success: false,
            error: t('contentModals:manageMaterial.errors.createFailed')
        };
    } catch (error) {
        console.error('Error creating material:', error);

        return {
            success: false,
            error: t('contentModals:manageMaterial.errors.saveFailed')
        };
    }
}
